<template>
  <div class="stat-detect">
    <StatPage
      :formModel="formModel"
      :requestData="requestData"
      :formButton="formButton"
      :statBusiType="2"
      :deviceModelBusiType="2"
    />
  </div>
</template>

<script>
import { merge } from 'lodash';
import { canvasToImg, downFile, dayTime } from '@/utils/utils';
import { getDetectData } from '@/api/stat';

export default {
  name: 'StatDetect',
  components: {
    StatPage: () => import('../components/stat-common')
  },
  data() {
    return {
      requestData: {},
      formModel: {
        sn: [],
        taskId: [],
        officeId: [],
        materialType: [],
        busiType: [],
        rangeDateVal: [dayTime().begin.getTime(), dayTime().end.getTime()],
        deviceModel: []
      },
      formButton: [
        {
          text: '查询',
          event: this.search
        },
        {
          text: '导出',
          code: '010621',
          loading: false,
          event: this.hisExport
        }
      ]
    };
  },
  methods: {
    rmLevelStr(obj) {
      // 去除>>级联
      return JSON.parse(JSON.stringify(obj).replace(/[^\"]*>>/g, ''));
    },
    getDetectDataPro() {
      return getDetectData(
        merge(
          {
            beginTime: this.formModel.rangeDateVal && this.formModel.rangeDateVal[0],
            endTime: this.formModel.rangeDateVal && this.formModel.rangeDateVal[1]
          },
          this.formModel
        )
      );
    },
    search() {
      this.getDetectDataPro().then(res => {
        this.requestData = res.data;
      });
    },
    hisExport(op) {
      op.loading = true;
      this.getDetectDataPro().then(res => {
        this.requestData = res.data;
        this.$nextTick().then(() => {
          canvasToImg().then(imgs => {
            downFile({
              url: '/stat/genDetectDataReport',
              method: 'post',
              data: merge(
                {
                  beginTime: this.formModel.rangeDateVal && this.formModel.rangeDateVal[0],
                  endTime: this.formModel.rangeDateVal && this.formModel.rangeDateVal[1],
                  pics: imgs
                },
                this.formModel
              )
            }).finally(() => {
              op.loading = false;
            });
          });
        });
      });
    }
  }
};
</script>
